import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { generateDataTestidAttribute } from '../../../services/testid-service';

import style from './modal-footer.less';

export const ModalFooter = ({ className = '', children }) => {
  return (
    <div {...generateDataTestidAttribute('modal-footer')} className={classNames(style['modal-footer'], className)}>
      {children}
    </div>
  );
};

ModalFooter.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};
